'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThreadList = undefined;

var _reselect = require('reselect');

var _getThreads = require('./getThreads');

var _isPersistedThread = require('../../threads/operators/isPersistedThread');

var getThreadList = exports.getThreadList = (0, _reselect.createSelector)([_getThreads.getThreads], function (threads) {
  if (!threads) {
    return undefined;
  }

  return threads.toList().filter(function (thread) {
    /**
     * We must have a latestMessage to display and the thread must be persisted
     * This means that we won't show the "stubbed thread" in the thread list
     */
    return !!thread.latestMessage && (0, _isPersistedThread.isPersistedThread)(thread);
  }).sortBy(function (thread) {
    return -thread.latestMessage.timestamp;
  });
});